const defaultSteps = [20, 60, 100];
export const calculateScrollTrackingStep = (position, scrollSize, containerSize, lastTracked, steps = defaultSteps) => {
  const scrollPercentage = Math.round(position / (scrollSize - containerSize) * 100);
  const step = getStep(steps, scrollPercentage);
  const shouldTrack = step && (!lastTracked || step > lastTracked);
  return shouldTrack ? step : undefined;
};
export const getStep = (steps, value) => steps.sort((a, b) => b - a).find(step => step <= value);